// React
import React from 'react';
// MdM
import DocList from '../../../../common/docs/docList/DocList';

const DocumentListPane = ({ 
  listDocuments,
  listConfig,
  isLoading,
  fetchListDocuments,
  selectedDocument,
  setSelectedDocument,
  filterCallback,
  filterChecked,
}) => {
  /* ------------------------------ Render ------------------------------ */
  return (
    <DocList 
      listDocuments={listDocuments} 
      listConfig={listConfig} 
      isLoading={isLoading} 
      fetchListDocuments={fetchListDocuments}
      selectedDocument={selectedDocument}
      setSelectedDocument={setSelectedDocument}
      addDisabled={listConfig.addDisabled === true}
      filterLabel={listConfig.filterLabel}
      filterCallback={filterCallback}
      filterChecked={filterChecked}
    />
  );
};

export default DocumentListPane; 